<script>
  import { onMount, tick } from "svelte";
  import {
    addToCart,
    business,
    isAdmin,
    loyaltyRules,
    userDetails,
    showSectionsSlider,
  } from "../stores.js";
  import * as BusinessDAL from "../dal/business-dal";

  import clone from "just-clone";

  import FaCheck from "svelte-icons/fa/FaCheck.svelte";
  import FaStar from "svelte-icons/fa/FaStar.svelte";
  import { calcItemPrice } from "../../functions/module/price-service";

  import FaFire from "svelte-icons/fa/FaFire.svelte";

  export let item;

  export let section;

  let isAvailable;

  let price = item.price;

  let isOpen = false;

  let detailsDiv;

  let detailsHeight;

  let descriptionDiv;

  let isFree;

  let loyaltyRule;

  $: {
    if ($loyaltyRules) {
      $loyaltyRules.forEach((rule) => {
        if (rule?.collectibleItems?.find((i) => i.id == item.id)) {
          loyaltyRule = rule;
        }

        if ($userDetails?.loyaltyCards?.hasOwnProperty([rule.id])) {
          const userCard = $userDetails.loyaltyCards[rule.id];
          if (
            userCard.numberOfStamps >= rule.collectibleCount &&
            !userCard.retired
          ) {
            if (rule.rewardItems.find((i) => i.id == item.id)) {
              isFree = true;
            }
          }
        }
      });
    }
  }

  $: {
    isAvailable = !(
      $business &&
      $business.unavailableItems &&
      $business.unavailableItems[item.name]
    );
  }

  //represents user selection, init options, select first item
  let options = {};
  if (item.options) {
    item.options.forEach((option) => {
      let idx = option.items.findIndex((optionItem) => {
        return !$business.outOfStock?.includes(optionItem.label);
      });
      if (idx != -1) options[option.name] = option.items[idx].label;
    });
  }

  //represents user selection, init checkboxes, copy from menu and set count to 0
  let checkboxes = {};
  if (item.checkboxes) {
    item.checkboxes.forEach((checkboxSection) => {
      checkboxes[checkboxSection.name] = {
        items: {},
        maxSelect: checkboxSection.maxSelect,
        selected: 0,
      };
    });
  }

  //recalc price when options or checkboxes are selected
  $: {
    try {
      price = calcItemPrice(item, options, checkboxes);
    } catch (e) {
      price = "Err";
    }
  }

  function add(e) {
    addToCart(item, section, options, checkboxes, price);
    e.preventDefault();
  }

  function openDetails() {
    detailsDiv.style.display = "block";
    detailsDiv.style.maxHeight = "unset";
    detailsDiv.style.position = "absolute";
    detailsDiv.style.left = "-999em";
    detailsHeight = detailsDiv.clientHeight + "px";
    detailsDiv.style.maxHeight = "0px";
    detailsDiv.style.position = "unset";
    detailsDiv.offsetHeight; //https://stackoverflow.com/questions/8210560/css-transitions-do-not-work-when-assigned-trough-javascript
    detailsDiv.style.maxHeight = detailsHeight;
  }

  function closeDetails() {
    detailsDiv.style.maxHeight = "0px";
  }

  onMount(async () => {
    await tick();
    if (detailsDiv) {
      detailsDiv.style.maxHeight = "0px";
      detailsDiv.style.display = "none";
    }
  });

  function checkboxClicked(section, checkbox) {
    let s = checkboxes[section.name];
    let b = s.items[checkbox.label];

    //if doesn't exists in checkboxes
    if (!b) {
      if (s.selected < s.maxSelect || s.maxSelect == 0) {
        s.items[checkbox.label] = clone(checkbox);
        s.selected++;
        s.items[checkbox.label].count = 1;
      }
    } else {
      //delete if exists
      s.selected -= b.count;
      delete s.items[checkbox.label];
    }
    checkboxes = checkboxes;
  }

  function checkboxAdd(section, checkbox) {
    let s = checkboxes[section.name];
    let b = s.items[checkbox.label];

    if (b.count < b.maxSelect && s.selected < s.maxSelect) {
      b.count++;
      s.selected++;
    }
    checkboxes = checkboxes;
  }

  function checkboxRemove(section, checkbox) {
    let s = checkboxes[section.name];
    let b = s.items[checkbox.label];

    if (b.count > 1) {
      s.selected--;
      b.count--;
    } else {
      s.selected--;
      delete s.items[checkbox.label];
    }
    checkboxes = checkboxes;
  }

  async function justSaved() {
    await tick();
    // detailsHeight = detailsDiv.clientHeight;
    setTimeout(() => {
      item.justSaved = false;
    }, 500);
  }

  $: {
    if (item.justSaved) {
      justSaved();
    }
  }

  let hideDetailsTimeout;

</script>

<main>
  {#if item.hidden}
    <div class="hidden">
      <h2>מוסתר</h2>
    </div>
  {:else if !isAvailable}
    <div class="notAvailable">
      <h2>אין כרגע</h2>
    </div>
  {/if}
  <div class="container">
    <div
      class="item"
      style="cursor: {item.options || item.checkboxes ? 'pointer' : 'unset'}"
      on:click={async () => {
        isOpen = !isOpen;
        if (isOpen) {
          openDetails();
          if (hideDetailsTimeout) clearTimeout(hideDetailsTimeout);
        } else {
          closeDetails();
          hideDetailsTimeout = setTimeout(() => {
            detailsDiv.style.display = 'none';
          }, 500);
        }
      }}
    >
      <div class="right">
        {#if $isAdmin}
          <input
            class="available"
            type="checkbox"
            bind:checked={isAvailable}
            on:click={(e) => {
              BusinessDAL.setItemAvailable($business.code, item.name, e.target.checked);
              e.stopPropagation();
            }}
          />
        {/if}
        <div class="header">
          <div class="title">
            {#if item.options.length > 0 || item.checkboxes.length > 0}
              <i class="arrow" class:up={isOpen} class:down={!isOpen} />
            {:else}
              <div class="marginRight" />
            {/if}
            <div class="name">{item.name}</div>
            <div class="tags">
              {#if item.isVegeterian}
                <div class="tag">
                  <img src="images/vegaterian-icon.svg" alt="מנה צמחונית" />
                </div>
              {:else if item.isVegan}
                <div class="tag">
                  <img src="images/vegan-icon.svg" alt="מנה טבעונית" />
                </div>
              {/if}
              {#if item.isSpicy}
                <div class="tag spicyIcon" alt="מנה חריפה">
                  <img src="images/spicy-icon.svg" alt="spicy icon" />
                </div>
              {:else if item.isVerySpicy}
                <div class="verySpicyIcon">
                  <div class="tag spicyIcon" alt="מנה חריפה מאוד">
                    <img src="images/spicy-icon.svg" alt="spicy icon" />
                  </div>
                  <div class="tag spicyIcon" alt="מנה חריפה מאוד">
                    <img src="images/spicy-icon.svg" alt="spicy icon" />
                  </div>
                </div>
              {/if}
            </div>
          </div>

          {#if loyaltyRule?.active}
            <div class="loyaltyRuleTitle">
              <div class="star">
                <FaStar />
              </div>
              <span>{loyaltyRule.title}</span>
            </div>
          {/if}

          {#if item.desc}
            <div
              class="description"
              class:descriptionClosed={descriptionDiv?.clientHeight > 55 && !isOpen}
              bind:this={descriptionDiv}
            >
              {item.desc}
            </div>
          {/if}
        </div>
      </div>
      {#if isFree}
        <div class="isFree"><span>חינם בהזמנה הבאה!</span></div>
      {/if}
      <div class="price">{price} <span>₪</span></div>
    </div>

    {#if item.checkboxes || item.options}
      <div class="details" bind:this={detailsDiv}>
        {#if item.options}
          <div class="options">
            {#each item.options as option (option.name)}
              <div class="cat">
                {#if option.name}
                  <div class="optionsName">{option.name}:</div>
                {/if}
                <div class="selectBlock">
                  {#each option.items as optionItem (optionItem.label)}
                    <div
                      class="select"
                      class:disabled={$business.outOfStock?.includes(optionItem.label)}
                    >
                      <label>
                        <div
                          class="radioBtn"
                          class:selected={optionItem.label == options[option.name]}
                        />
                        <input
                          value={optionItem.label}
                          type="radio"
                          bind:group={options[option.name]}
                        />
                        {optionItem.label}
                        {#if optionItem.priceVar}(₪{optionItem.priceVar}){/if}
                      </label>
                    </div>
                  {/each}
                </div>
              </div>
            {/each}
          </div>
        {/if}

        {#if item.checkboxes}
          {#each item.checkboxes as section (section.name)}
            <div class="optionsName">
              {section.name}
              {#if section.maxSelect > 0}
                ({section.maxSelect}
                /
                {checkboxes[section.name].selected})
              {/if}
            </div>
            <div class="selectBlock oneColGrid">
              {#each section.items as checkbox (checkbox.label)}
                {#if checkbox.label}
                  <div class="checkbox">
                    <div
                      class="checkboxClickArea"
                      on:click={checkboxClicked(section, checkbox)}
                      class:disabled={checkbox.maxSelect == 0 || $business.outOfStock?.includes(checkbox.label)}
                    >
                      <div class="checkboxSquare">
                        {#if checkboxes[section.name].items[checkbox.label]?.count > 0}
                          <FaCheck />
                        {/if}
                      </div>

                      <span>{checkbox.label}
                        {#if checkbox.priceVar}
                          (₪{checkbox.priceVar})
                        {/if}</span>
                    </div>
                    {#if checkboxes[section.name].items[checkbox.label] && checkbox.maxSelect > 1}
                      <div class="count">
                        x
                        {checkboxes[section.name].items[checkbox.label].count}
                      </div>
                    {/if}

                    {#if checkboxes[section.name].items[checkbox.label]}
                      {#if checkbox.maxSelect > 1}
                        <div class="countBtns">
                          <div
                            class="countBtn"
                            on:click={checkboxAdd(section, checkbox)}
                          >
                            +
                          </div>
                          <div
                            class="countBtn"
                            on:click={checkboxRemove(section, checkbox)}
                          >
                            -
                          </div>
                        </div>
                      {/if}
                    {/if}
                  </div>
                {/if}
              {/each}
            </div>
          {/each}
        {/if}
        {#if loyaltyRule?.active}
          <div class="loyaltyRuleDetails">
            <div class="header">
              <div class="star">
                <FaStar />
              </div>
              <div class="title">משתתף במבצע: {loyaltyRule.title}</div>
            </div>
            <div class="listHeader">
              קנה
              {loyaltyRule.collectibleCount}
              מהמוצרים הבאים:
            </div>
            <div class="list">
              {#each loyaltyRule.collectibleItems as collectibleItem}
                <div class="listItem">{collectibleItem.name}</div>
              {/each}
            </div>
            <div class="listHeader">קבל אחד מהמוצרים הבאים</div>
            <div class="list">
              {#each loyaltyRule.rewardItems as rewardItem}
                <div class="listItem">{rewardItem.name}</div>
              {/each}
            </div>
          </div>
        {/if}
        {#if item.isVegan || item.isVegeterian || item.isSpicy || item.isVerySpicy}
          <div class="tagsDetails">
            {#if item.isVegeterian}
              <div class="tag">
                <img src="images/vegaterian-icon.svg" alt="מנה צמחונית" />
              </div>
              <span>מנה צמחונית</span>
            {:else if item.isVegan}
              <div class="tag">
                <img src="images/vegan-Icon.svg" alt="מנה טבעונית" />
              </div>
              <span>מנה טבעונית</span>
            {/if}
            {#if item.isSpicy}
              <div class="tag spicyIcon" alt="מנה חריפה">
                <img src="images/spicy-icon.svg" alt="spicy icon" />
              </div>
              <span>מנה חריפה</span>
            {:else if item.isVerySpicy}
              <div class="verySpicyIcon">
                <div class="tag spicyIcon" alt="מנה חריפה מאוד">
                  <img src="images/spicy-icon.svg" alt="spicy icon" />
                </div>
                <div class="tag spicyIcon" alt="מנה חריפה מאוד">
                  <img src="images/spicy-icon.svg" alt="spicy icon" />
                </div>
              </div>
              <span>מנה חריפה מאוד</span>
            {/if}
          </div>
        {/if}
      </div>
    {/if}
  </div>
  <button
    class="addBtn"
    on:mousedown={add}
    on:mouseleave={(e) => {
      e.target.blur();
    }}
    style={$showSectionsSlider ? 'top:90px' : 'top:12px'}
  >
    <span>+</span>
  </button>
</main>

<style>
  .tagsDetails {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    margin: 30px 30px;
  }
  .tagsDetails > span {
    margin-left: 20px;
  }
  .verySpicyIcon {
    color: orange;
    display: flex;
  }

  .verySpicyIcon > :nth-child(2) {
    margin-right: -2px;
  }

  .spicyIcon {
    margin-left: -10px;
  }
  .tags {
    display: flex;
    gap: 8px;
    margin-right: 12px;
  }

  .tag {
    max-width: 20px;
    max-height: 20px;
    display: flex;
  }

  .tag > * {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }

  .loyaltyRuleDetails {
    margin: 20px;
    padding: 20px;
    border: 3.5px dashed #ff5c5c;
    border-radius: 12px;
    margin-left: 40px;
  }

  .loyaltyRuleDetails > .header {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
  }

  .loyaltyRuleDetails > .listHeader {
    margin: 15px;
    font-size: 1.4rem;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-decoration-color: #919191;
  }

  .loyaltyRuleDetails > .list {
    padding-right: 30px;
  }

  .loyaltyRuleDetails > .list > .listItem {
    display: list-item;
    font-size: 1.4rem;
    margin: 4px;
  }
  .loyaltyRuleDetails > .header > .title {
    margin-right: 5px;
    font-size: 1.3rem;
    direction: rtl;
    text-align: right;
  }

  .loyaltyRuleTitle {
    display: flex;
    align-items: center;
    margin-right: 14px;
    font-size: 1.3rem;
    direction: rtl;
    text-align: right;
    margin: 0 10px;
    margin-top: 8px;
  }

  .loyaltyRuleTitle > span {
    margin-right: 5px;
  }

  .loyaltyRuleTitle > .star,
  .loyaltyRuleDetails > .header > .star {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    transform: rotate(4deg);
    color: var(--red1);
  }
  .isFree {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #35e541ed;
    text-align: center;
    border-radius: 100%;
    color: white;
    font-weight: 500;
    font-style: italic;
    transform: rotate(5deg);
    line-height: 0.85;
    font-size: 1.3rem;
    margin-right: 5px;
    margin-left: 5px;
  }
  .radioBtn {
    width: 10px;
    height: 10px;
    border: 2px solid #8f8f8f;
    display: inline-flex;
    position: absolute;
    border-radius: 100px;
    align-items: center;
    justify-content: center;
    padding: 2px;
  }

  .radioBtn.selected {
    border: 2px solid #8f8f8f;
  }

  .radioBtn.selected::after {
    background: blue;
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 100px;
  }

  main {
    direction: rtl;
    padding: 10px 0px 10px 10px;
    color: #2e2e2e;
    position: relative;
    display: flex;
    border-bottom: 3px dotted #bcbcbc;
    user-select: none;
  }

  .container {
    width: calc(100% - 55px);
    display: inline-block;
    position: relative;
  }

  input {
    margin: 0;
    margin-left: 5px;
  }

  input[type="radio"] {
    opacity: 0;
  }

  .checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.75rem;
    min-height: 60px;
  }

  .disabled {
    text-decoration: line-through;
    opacity: 0.5;
    pointer-events: none;
  }

  .checkboxClickArea {
    display: flex;
    align-items: center;
  }

  .checkboxSquare {
    width: 18px;
    min-width: 18px;
    height: 18px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 2px;
    display: flex;
    padding: 2px;
    margin: 10px;
  }

  .count {
    min-width: 28px;
    margin-right: auto;
  }

  .countBtns {
    display: flex;
    border-radius: 3px;
    overflow: hidden;
    gap: 3px;
    /* margin-right: auto; */
    min-width: 78px;
  }

  .countBtn {
    min-width: 35px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f1f1d4;
    border-radius: 3px;
    border: 1px solid #dbdbdb;
  }

  .selectBlock {
    margin-top: 10px;
    margin-right: 10px;
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: auto auto;
  }

  .oneColGrid {
    grid-template-columns: auto;
  }

  .item {
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    width: 100%;
    user-select: none;
    font-family: "Rubik";
    font-weight: 500;
    font-size: 18px;
    color: var(--grey1);
  }

  .header {
    width: 100%;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .price {
    min-width: fit-content;
    margin-right: auto;
    margin-bottom: 10px;
    margin-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    display: inline-flex;
    align-items: center;
    text-align: left;
    align-self: baseline;
  }

  .details {
    width: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    padding-right: 30px;
    will-change: max-height;
    max-height: 0;
  }

  .cat {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .optionsName {
    margin: 25px 0px 0px 0;
    display: inline-block;
    margin-left: 10px;
    font-size: 15px;
    font-weight: 700;
  }

  .select {
    display: inline-flex;
    align-items: center;
    margin-left: 15px;
    margin-bottom: 12px;
  }

  .options {
    display: block;
  }

  label {
    display: inline-block;
    margin-left: 10px;
    font-size: 1.75rem;
    max-width: 210px;
    position: relative;
  }

  .addBtn {
    width: 50px;
    height: 50px;
    padding: 0;
    margin: 0;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: #e5f6ff;
    color: #28b0ff;
    font-size: 20px;
    cursor: pointer;
    font-weight: 900;
    margin-right: auto;
    min-width: 50px;
    position: sticky;
    transition: top 0.2s ease-out;
    transition: background 0.2s ease-out;
  }

  .addBtn:hover {
    background: #56c1ff;
    color: #ffffff;
  }
  .addBtn:focus {
    background: #fff;
    border: 3px solid;
    color: var(--blue1);
  }

  .arrow {
    margin: 15px;
    border-radius: 3px;
    border: solid #373533;
    border-width: 0 6px 6px 0;
    display: inline-block;
    padding: 4px;
  }

  .down {
    transform: rotate(45deg);
  }
  .up {
    transform: rotate(-135deg);
  }
  .name {
    /* max-width: 274px; */
    display: inline-block;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-top: 15px;
  }

  .description {
    font-size: 15px;
    margin-right: 15px;
    margin-top: 7px;
    margin-bottom: 7px;
    font-weight: 300;
    margin-left: -64px;
    transition: max-height 0.3s ease-out;
  }

  .descriptionClosed {
    max-height: 55px;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(180deg, black, transparent);
  }

  .marginRight {
    width: 20px;
    height: 100%;
  }

  .right {
    display: flex;
    align-items: center;
  }

  .available {
    color: red;
    z-index: 1;
    margin-right: 10px;
  }

  .available:checked {
    background: transparent;
  }

  .notAvailable > h2 {
    display: block;
    padding: 4px 35px;
    background: white;
    border-radius: 6px;
    border: 3px solid var(--red2);
  }

  @media only screen and (max-width: 470px) {
    .item {
      font-size: 16px;
      margin-right: 0px;
    }
  }
  .notAvailable {
    width: 100%;
    height: 100%;
    position: absolute;
    background: repeating-linear-gradient(
      45deg,
      var(--red2) 0%,
      var(--red2) 6%,
      #e6e6e6bd 0%,
      #e6e6e6bd 12%
    );
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(-10px);
  }

  .hidden {
    width: 100%;
    height: 100%;
    position: absolute;
    background: repeating-linear-gradient(
      45deg,
      var(--orange1) 0%,
      var(--orange1) 6%,
      #e6e6e6bd 0%,
      #e6e6e6bd 12%
    );
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(-10px);
  }

  .hidden > h2 {
    display: block;
    padding: 4px 35px;
    background: white;
    border-radius: 6px;
    border: 3px solid var(--orange1);
  }

</style>
